import React, { useCallback, useEffect, useState } from "react";
import "./../Form.scss";
import "./FaturamentosForm.scss";
import { useHistory, useParams } from "react-router";
import service from "../../../services/campanhas";
import { get, post } from "../../../services/faturamentos";
import serviceCatalogos from "../../../services/catalogos";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import {
  sumValuesArray,
} from "../../../utils/utils";
import { actions as actionsSite } from "../../../redux/actions/site";
import { useDispatch } from "react-redux";
import { currencyToFloat, formatCurrency } from "../../../utils/Money";
import TitleModule from "../../../components/title/TitleModule";

const FaturamentosForm = (props) => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [catalogosColunas, setCatalogosColunas] = useState([]);
  const params = useParams();
  const history = useHistory();
  const [campanha, setCampanha] = useState({});
  const [faturamentos, setFaturamentos] = useState([]);
  const [faturamentosCatalogos, setFaturamentosCatalogos] = useState([]);

  const { handleSubmit } = useForm();

  const saveFaturamento = async () => {
    const body = { faturamentos: faturamentosCatalogos, campanha: campanha._id };
    dispatch(actionsSite.setLoadingMsg("Enviando dados..."));
    const res = await post(`save-faturamentos`, body);
    dispatch(actionsSite.setLoadingMsg(res.msg));
    setTimeout(() => {
        dispatch(actionsSite.setLoadingMsg(""));
        
    }, 3000);
  };

  const carregarCampanha = useCallback(async (id) => {
    const campanhaInicial = await service.getById(id);
    setCampanha(campanhaInicial);
    
    await carregarfaturamentos(id);
    setLoading(false);
  }, []);

  const carregarfaturamentos = useCallback(async (campanhaId) => {
    const faturamentosCampanha = await get(`by-campanha/${campanhaId}`);
    setFaturamentos(faturamentosCampanha);
    setLoading(false);
  }, []);

  useEffect(() => {
    const run = async () => {
      const _resCatalogos = await serviceCatalogos.get(
        `?catalogo=NULL&sort=apelido&active=true`
      );      

      const catalogosColunasArr = _resCatalogos.rows.map((e) => {
        if (e.codigo) {
          return {codigo:e.codigo, nome:e.apelido.toString().toUpperCase()};
        }
        return null;
      }).sort((a,b)=>(a.nome > b.nome ? 1 : -1));
      const indexAmway = catalogosColunasArr.findIndex(c=>(c.codigo==="amway"));
      if(indexAmway){
        catalogosColunasArr.splice(indexAmway,1);
        catalogosColunasArr.push({ codigo: "amway", nome: "Amway" });
      }
      catalogosColunasArr.push({ codigo: "diversos", nome: "Dvs" });

      setCatalogosColunas(catalogosColunasArr);

      if (params.id) {
        carregarCampanha(params.id);
      } else {
        setLoading(false);
      }
    };
    run();
  }, [carregarCampanha, params.id]);

  useEffect(() => {
    faturamentosOrganizados();
  }, [faturamentos]);

  const faturamentosOrganizados = () => {
    const faturamentosOrg = [];
    for(let index = 0; index < catalogosColunas.length; index ++) {
      const cat = catalogosColunas[index];
      const faturamento = faturamentos.find((f)=>(f.catalogoCodigo===cat.codigo && f.campanha === params.id));

      const fat = {
        index,
        campanha: params.id,
        catalogoCodigo: cat.codigo,
        enviado: faturamento && faturamento.enviado || 0,
        faturado: faturamento && faturamento.faturado || 0,
        pedidos: faturamento && faturamento.pedidos || 0,
        descontoRevendedora: faturamento && faturamento.descontoRevendedora || cat.codigo === 'abelha'?0:30,
        lucroPercentual: faturamento && faturamento.lucroPercentual || cat.codigo === 'abelha'?35:18,
        lucroReal: faturamento && faturamento.lucroReal || 0,
        
      };

      faturamentosOrg.push(fat);
    }
    
    setFaturamentosCatalogos(faturamentosOrg);
  }

  const getTotal = attr => {
    const values = faturamentosCatalogos.map(f=>(parseFloat(f[attr])));

    return (sumValuesArray(values));
  }

  const getTotalCalculado = attr => {
    const values = [];
    for (let faturamento of faturamentosCatalogos) {
      const {enviado, faturado, lucroPercentual, descontoRevendedora} = faturamento;
      const descontoRevendedoraValor = enviado * descontoRevendedora / 100;
      const baseCalculo = enviado - descontoRevendedoraValor;
      const lucroEstimado = baseCalculo * lucroPercentual / 100;
      if(attr === 'descontoRevendedoraValor'){
        values.push((descontoRevendedoraValor));
      } else if(attr === 'baseCalculo'){
        values.push((baseCalculo));
      } else if(attr === 'lucroEstimado'){
        values.push((lucroEstimado));
      }
    }
    return (sumValuesArray(values));
  }

  const renderBotaoSalvar = () => {
    return (
      <div className="form faturamento">
        <form
          onSubmit={handleSubmit(saveFaturamento)}
          className="formModule branco FaturamentosForm"
        >
          
          <div className="acoes mt-10">
            <button
              type="button"
              className="cancelar"
              onClick={() => history.push("/painel/faturamentos")}
              >
              <FontAwesomeIcon icon={faArrowLeft} /> Voltar
            </button>
            <button
              type="button"
              className="salvar"
              onClick={() => saveFaturamento()}
            >
              <FontAwesomeIcon icon={faSave} /> Salvar
            </button>
          </div>
        </form>
      </div>
    );
  };
  
  const setValorFaturamento = (params,attr, valor) => {
    const indexFaturamento = faturamentosCatalogos.findIndex((f)=>(f.index===params.index));
    const cloneFaturamentos = [...faturamentosCatalogos];
    cloneFaturamentos[indexFaturamento][attr] = valor;
    setFaturamentosCatalogos(cloneFaturamentos);
  }

  const renderFaturamentos = () => {

    return catalogosColunas.map((cat, index) => {
      const faturamento = faturamentosCatalogos.find(f=>(cat.codigo===f.catalogoCodigo));
      const {enviado, faturado, lucroPercentual, pedidos, descontoRevendedora, lucroReal} = faturamento;
      const diferenca = enviado - faturado ;
      const descontoRevendedoraValor = enviado * descontoRevendedora / 100;
      const baseCalculo = enviado - descontoRevendedoraValor;
      const lucroEstimado = baseCalculo * lucroPercentual / 100;

      return (
        <tr key={index}>
          <td>{cat.nome}</td>
          <td>
            <input className={"hasText"} value={formatCurrency(enviado)} type="text"
              onChange={(e) => {
                const valor = currencyToFloat(e.target.value);
                setValorFaturamento(faturamento, 'enviado', valor);
              }}
            />
          </td>
          <td>
            <input className={"hasText"} value={formatCurrency(faturado)} type="text"
              onChange={(e) => {
                const valor = currencyToFloat(e.target.value);
                setValorFaturamento(faturamento, 'faturado', valor);
              }}
            />
          </td>
          <td>
            {formatCurrency(diferenca)}
          </td>
          <td>
            <input className={"hasText"} value={pedidos} type="number"
              onChange={(e) => {
                const valor = e.target.value;
                setValorFaturamento(faturamento, 'pedidos', valor);
              }}
            />
          </td>
          <td>
            <input className={"hasText"} value={formatCurrency(descontoRevendedora)} type="text"
              onChange={(e) => {
                const valor = currencyToFloat(e.target.value);
                setValorFaturamento(faturamento, 'descontoRevendedora', valor);
              }}
            />
          </td>
          <td>
            {formatCurrency(descontoRevendedoraValor)}
          </td>
          <td>
            {formatCurrency(baseCalculo)}
          </td>
          <td>
            <input className={"hasText"} value={formatCurrency(lucroPercentual)} type="text"
              onChange={(e) => {
                const valor = currencyToFloat(e.target.value);
                setValorFaturamento(faturamento, 'lucroPercentual', valor);
              }}
            />
          </td>
          <td>
            {formatCurrency(lucroEstimado)}
          </td>
          <td>
            <input className={"hasText"} value={formatCurrency(lucroReal)} type="text"
              onChange={(e) => {
                const valor = currencyToFloat(e.target.value);
                setValorFaturamento(faturamento, 'lucroReal', valor);
              }}
            />
          </td>
        </tr>
      );
    });
  };


  return (
    <>
      {!loading && (
        <TitleModule
          titulo={`Faturamentos - Editar Campanha ${campanha.codigo}`}
        />
      )}
      {!loading && (
        <>
          {renderBotaoSalvar()}
          <form className="formModule branco FaturamentosForm">
            <div className="break"></div>
            <div className="break"></div>
            
            <div className="crudView" style={{ width: "100%" }}>
              <div className="gridView">
                <table
                  cellPadding="0"
                  cellSpacing="0"
                  className="faturamentosGrid"
                >
                  <thead>
                    <tr>
                      <td>Catálogo</td>
                      <td>Enviado</td>
                      <td>Faturado</td>
                      <td>Diferença</td>
                      <td>Pedidos</td>
                      <td>Desc. Rev. %</td>
                      <td>Desc. Rev.</td>
                      <td>Base Cálc.</td>
                      <td>% Lucro</td>
                      <td>Lucro Est.</td>
                      <td>Lucro Real</td>
                    </tr>
                  </thead>
                  <tbody>{renderFaturamentos()}</tbody>
                  <tfoot>
                    <tr className="totais">
                      <td align="center">Totais</td>
                      <td>Enviado</td>
                      <td>Faturado</td>
                      <td>Diferença</td>
                      <td>Pedidos</td>
                      <td>Desc. Rev. %</td>
                      <td>Desc. Rev.</td>
                      <td>Base Cálc.</td>
                      <td>% Lucro</td>
                      <td>Lucro Est.</td>
                      <td>Lucro Real</td>
                    </tr>
                    <tr className="">
                      <td></td>
                      <td>{formatCurrency(getTotal('enviado'))}</td>
                      <td>{formatCurrency(getTotal('faturado'))}</td>
                      <td>{formatCurrency(getTotal('enviado')-getTotal('faturado'))}</td>
                      <td>{(getTotal('pedidos'))}</td>
                      <td>-</td>
                      <td>{formatCurrency(getTotalCalculado('descontoRevendedoraValor'))}</td>
                      <td>{formatCurrency(getTotalCalculado('baseCalculo'))}</td>
                      <td>-</td>
                      <td>{formatCurrency(getTotalCalculado('lucroEstimado'))}</td>
                      <td>{formatCurrency(getTotal('lucroReal'))}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </form>
          {renderBotaoSalvar()}
        </>
      )}
      {loading && "Carregando..."}
    </>
  );
};

export default FaturamentosForm;
